<template>
  <div class="app-wrapper">
    <navbar/>
    <p v-show="!isAgent" style="color: red;margin: 0 auto;display: inline-block;width: 968px;text-align: left">
      {{ this.language === 'zh_CN' ? '格林威治时间' : 'GMT' }} {{ this.showTime }}
    </p>
    <div class="main-container">
      <app-main/>
    </div>
    <app-footer/>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import AppMain from './components/AppMain'
import AppFooter from './components/Footer'
import {mapGetters} from "vuex";

export default {
  name: 'Layout',
  components: {Navbar, AppMain, AppFooter},
  data() {
    return {
      showTime: ''
    }
  },
  computed: {
    ...mapGetters([
      'language',
      'userCode',
      'username',
      'isAgent',
      'permission_routes'
    ]),
  },
  mounted() {
    setInterval(() => {
      this.showTime = this.getYMDHMS()
    }, 1000)
  },
  methods: {
    getYMDHMS() {
      let oDate=new Date();
      let dateArr = oDate.toGMTString().split(' ')
      let year = oDate.getFullYear()
      let month = oDate.getMonth() + 1
      let date = dateArr[1]
      let time = dateArr[4]
      if (month < 10) {
        month = '0' + month
      }
      if (this.language === 'zh_CN') {
        return time + ' ' + year + '/' + month + '/' + date
      } else {
        return time + ' ' + date + '/' + month + '/' + year
      }
    }
  }
}
</script>

<style>

</style>
